export default "__VITE_ASSET__CeqqE2Vy__"